import React, { useState } from 'react';

const Step3Work = ({ data, availableApps, onChange, onNext, onBack }) => {
  const [errors, setErrors] = useState({});

  const handleChange = (field, value) => {
    onChange({ [field]: value });
    if (errors[field]) setErrors((prev) => ({ ...prev, [field]: '' }));
  };

  const handleAppToggle = (appId) => {
    const apps = data.requested_apps || [];
    const updated = apps.includes(appId)
      ? apps.filter((id) => id !== appId)
      : [...apps, appId];
    onChange({ requested_apps: updated });
  };

  const validate = () => {
    const e = {};
    if (!data.department || data.department.trim().length < 2) e.department = 'Department is required';
    if (!data.designation || data.designation.trim().length < 2) e.designation = 'Designation is required';
    if (!data.emergency_contact_name || data.emergency_contact_name.trim().length < 2) e.emergency_contact_name = 'Contact name is required';
    if (!data.emergency_contact_phone || !data.emergency_contact_phone.match(/^[6-9]\d{9}$/)) e.emergency_contact_phone = 'Enter a valid 10-digit number';
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const handleNext = () => { if (validate()) onNext(); };

  return (
    <div className="ob-step">
      <div className="ob-step__header">
        <h2>Work & Access</h2>
        <p>Tell us about your role and select the tools you need.</p>
      </div>

      <div className="ob-grid ob-grid--2">
        <div className="ob-field">
          <label>Department <span className="ob-required">*</span></label>
          <input type="text" className={`ob-input ${errors.department ? 'ob-input--error' : ''}`} placeholder="e.g., Engineering" value={data.department} onChange={(e) => handleChange('department', e.target.value)} />
          {errors.department && <span className="ob-error">{errors.department}</span>}
        </div>
        <div className="ob-field">
          <label>Designation <span className="ob-required">*</span></label>
          <input type="text" className={`ob-input ${errors.designation ? 'ob-input--error' : ''}`} placeholder="e.g., Software Engineer" value={data.designation} onChange={(e) => handleChange('designation', e.target.value)} />
          {errors.designation && <span className="ob-error">{errors.designation}</span>}
        </div>
      </div>

      <div className="ob-section">
        <h3 className="ob-section__title">Emergency Contact</h3>
        <div className="ob-grid ob-grid--2">
          <div className="ob-field">
            <label>Contact Name <span className="ob-required">*</span></label>
            <input type="text" className={`ob-input ${errors.emergency_contact_name ? 'ob-input--error' : ''}`} placeholder="Person to contact" value={data.emergency_contact_name} onChange={(e) => handleChange('emergency_contact_name', e.target.value)} />
            {errors.emergency_contact_name && <span className="ob-error">{errors.emergency_contact_name}</span>}
          </div>
          <div className="ob-field">
            <label>Contact Phone <span className="ob-required">*</span></label>
            <div className="ob-input-group">
              <span className="ob-input-group__prefix">+91</span>
              <input type="tel" className={`ob-input ${errors.emergency_contact_phone ? 'ob-input--error' : ''}`} placeholder="9876543210" maxLength="10" value={data.emergency_contact_phone} onChange={(e) => handleChange('emergency_contact_phone', e.target.value.replace(/\D/g, ''))} />
            </div>
            {errors.emergency_contact_phone && <span className="ob-error">{errors.emergency_contact_phone}</span>}
          </div>
        </div>
      </div>

      {availableApps.length > 0 && (
        <div className="ob-section">
          <h3 className="ob-section__title">Application Access</h3>
          <p className="ob-section__desc">Select the apps you need. Admin will review your request.</p>
          <div className="ob-apps-grid">
            {availableApps.map((app) => (
              <label key={app.id} className={`ob-app-card ${data.requested_apps?.includes(app.id) ? 'ob-app-card--selected' : ''}`}>
                <input type="checkbox" checked={data.requested_apps?.includes(app.id) || false} onChange={() => handleAppToggle(app.id)} />
                <span className="ob-app-card__icon">{app.icon || '\ud83d\udcf1'}</span>
                <span className="ob-app-card__name">{app.name}</span>
              </label>
            ))}
          </div>
        </div>
      )}

      <div className="ob-actions">
        <button className="ob-btn ob-btn--ghost" onClick={onBack}>Back</button>
        <button className="ob-btn ob-btn--primary" onClick={handleNext}>
          Continue
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M3 7h8M8 4l3 3-3 3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
        </button>
      </div>
    </div>
  );
};

export default Step3Work;
